const SliderData = [
    {
        id:1,
        image:"Images/sliders/slider1.png",
        title:"Getting started with Mobile App Development in Android, Flutter and ios",
        description:"This is your path to a career in Mobile App Development. In this program, you’ll learn in-demand skills that can have you job-ready in less than 6 months. No degree or experience required."
    },
    {
        id:2,
        image:"Images/sliders/slider2.png",
        title:"Full stack Web Development with react, php, html, css, javascript and many more.",
        description:"This is your path to a career in Web Development. In this program, you’ll learn in-demand skills that can have you job-ready in less than 6 months. No degree or experience required."
    },
    {
        id:3,
        image:"Images/sliders/slider4.png",
        title:"Acquire skill in Graphic Designing. Learn on demand skills in Photoshop, Adobe Illustrator, Adobe XD, and Figma.",
        description:"This is your path to a career in Graphic Designing. In this program, you’ll learn in-demand skills that can have you job-ready in less than 6 months. No degree or experience required."
    },
    {
        id:4,
        image:"Images/sliders/slider5.png",
        title:"Getting Started with Game Development(Unity). Learn On Demand Skills in Game Development.",
        description:"This is your path to a career in Game Development. In this program, you’ll learn in-demand skills that can have you job-ready in less than 6 months. No degree or experience required."
    },
    {
        id:5,
        image:"Images/sliders/slider3.png",
        title:"Getting Started with Digital Marketing & Social Media Marketing Professional Certificate",
        description:"This is your path to a career in digital marketing. In this program, you’ll learn in-demand skills that can have you job-ready in less than 6 months. No degree or experience required."
    }


]
export default SliderData